import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-receipt-file',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './receipt-file.component.html',
  styleUrl: './receipt-file.component.scss'
})
export class ReceiptFileComponent {

  invoice = {
    company: {
      name: 'Circled Proptech LLP',
      address: '44/1, F1, Blk A, Deepa Residency, R.K Mutt Road, Ulsoor, Bangalore – 560 008, India',
      pan: 'AASFC7433K',
      gst: '29AASFC7433K1ZS'
    },
    invoiceNo: 'CRPL/000XX:202X',
    place: 'Bangalore',
    date: '',
    reverseCharge: 'NO',
    state: 'KARNATAKA',
    stateCode: '29',
    billTo: {
      name: '',
      contact: ''
    },
    items: [
      {
        description: 'Circled Plus – Quarterly Subscription Charges',
        sac: '997222',
        qty: 1,
        rate: 3000,
        amount: 3000,
        discount: 0,
        taxable: 3000,
        cgstRate: 9,
        cgstAmount: 270,
        sgstRate: 9,
        sgstAmount: 270,
        total: 3540
      }
    ],
    totals: {
      beforeTax: 3000,
      cgst: 270,
      sgst: 270,
      totalTax: 540,
      afterTax: 3540
    }
  };
  
}
